import React from 'react';
import { usePopup } from '../context/PopupContext';
import './GlobalPopup.css';

const GlobalPopup = () => {
  const { popup } = usePopup();

  if (!popup.show) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-card">
        <div className="popup-header">
          <h3>{popup.title || (popup.type === 'confirm' ? 'Confirm' : 'Alert')}</h3>
        </div>
        <div className="popup-body">
          <p>{popup.message}</p>
        </div>
        <div className="popup-footer">
          {popup.type === 'confirm' && (
            <button className="btn-popup-cancel" onClick={popup.onCancel}>
              Cancel
            </button>
          )}
          <button className="btn-popup-confirm" onClick={popup.onConfirm}>
            {popup.type === 'confirm' ? 'Confirm' : 'OK'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlobalPopup;
